import { create } from 'zustand';
import { IConfigurationData } from '../../../../../types/product.configuration.types';

interface ConfigurationGlobalState {
  isToolsAsociatedConfigModalOpen: boolean;
  setIsToolsAsociatedConfigModalOpen: (value: boolean) => void;
  isInactiveConfigModalOpen: boolean;
  setIsInactiveConfigModalOpen: (value: boolean) => void;
  isDeleteConfigModalOpen: boolean;
  setIsDeleteConfigModalOpen: (value: boolean) => void;
  isAddConfigModalOpen: boolean;
  setIsAddConfigModalOpen: (value: boolean) => void;
  configUnit: IConfigurationData | null;
  setConfigUnit: (value: IConfigurationData | null) => void;
  isReviewConfigModalOpen: boolean;
  setIsReviewConfigModalOpen: (value: boolean) => void;
  searchText: string;
  setSearchText: (value: string) => void;
}

const useConfigurationGlobalState = create<ConfigurationGlobalState>(set => ({
  isToolsAsociatedConfigModalOpen: false,
  setIsToolsAsociatedConfigModalOpen: value => set({ isToolsAsociatedConfigModalOpen: value }),
  isInactiveConfigModalOpen: false,
  setIsInactiveConfigModalOpen: value => set({ isInactiveConfigModalOpen: value }),
  isDeleteConfigModalOpen: false,
  setIsDeleteConfigModalOpen: value => set({ isDeleteConfigModalOpen: value }),
  isAddConfigModalOpen: false,
  setIsAddConfigModalOpen: value => set({ isAddConfigModalOpen: value }),
  configUnit: null,
  setConfigUnit: value => set({ configUnit: value }),
  isReviewConfigModalOpen: false,
  setIsReviewConfigModalOpen: value => set({ isReviewConfigModalOpen: value }),
  searchText: '',
  setSearchText: value => set({ searchText: value })
}));

export default useConfigurationGlobalState;
